const getPropertyNamesMap = ({ shared }) => ({
  propertyNamesRequestStatus: shared.propertyNamesRequestStatus,
  propertyNamesMap: shared.propertyNamesMap,
});

export default getPropertyNamesMap;
